
import React from "react";
import "../g.css";

export default function Refund() {
  const address = "Wear & Wonder Boutique LLC";

  return (
    <main className="policy-container">
      <div className="policy-wrapper">
        <h1 className="policy-title">Return and Refund Policy</h1>


        <section>
          <p>
            We want you to be fully satisfied with your purchase. If you're not happy with your item, we offer returns or exchanges within <strong>14 days of receipt</strong>, and a <strong>30-day return window</strong> in some cases, depending on your region.
          </p>

          <p><strong>To be eligible for a return or exchange:</strong></p>
          <ul>
            <li>You must <a href="/Contact-us">contact us</a> within 14 days.</li>
            <li>Item must be unused, unwashed, unworn, in saleable condition, with original tags and packaging.</li>
            <li>You’ll need the receipt or proof of purchase.</li>
          </ul>
        </section>

        <section>
          <p><strong>Please note:</strong></p>
          <ul>
            <li>Returns must be approved before sending items back. Unapproved returns will not be accepted.</li>
            {/* <li>Return shipping fees are <strong>$20</strong> for the US and <strong>$40</strong> for other regions.</li> */}
            <li>Original shipping costs are non-refundable.</li>
          </ul>

          <p>
            If your return is accepted, you’ll receive a return label and instructions. Refunds are processed within 10 business days after we inspect your return. If you haven’t received your refund within 15 business days of approval, <a href="/Contact-us">contact us</a>.
          </p>
        </section>

        <section>
          <h2>Damages & Issues</h2>
          <p>
            Inspect your order on arrival. If damaged, defective, or incorrect, <a href="/Contact-us">contact us</a> immediately and we’ll resolve it.
          </p>
        </section>

        <section>
          <h2>Exchanges</h2>
          <p>
            For exchanges, return your original item and place a new order after approval. Availability of exchange items is not guaranteed.
          </p>
        </section>

        <section>
          <h2>Non-returnable Items</h2>
          <p>
            Sale items, custom items, personal care products, hazardous materials, and flammable liquids/gases are non-returnable.
          </p>
        </section>

        <section>
          <h2>Shipping & Responsibility</h2>
          <ul>
            <li><strong>Free shipping</strong> on US orders over <strong>$200</strong>.</li>
            <li>No shipping to P.O. Boxes.</li>
            <li>We are not responsible for incorrect shipping addresses.</li>
            <li>We are not liable for stolen, lost, or damaged packages in transit.</li>
          </ul>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            For return/refund questions, <a href="/Contact-us">contact us</a> with your order number and item details.
          </p>
        </section>
      </div>
    </main>
  );
}
